import { createAsyncThunk } from '@reduxjs/toolkit';

import { getSubmission as getSubmissionService } from './services';

const GET_SUBMISSION = 'GET_SUBMISSION';
export const getSubmission = createAsyncThunk(
  GET_SUBMISSION,
  getSubmissionService,
);
